import React from 'react';
import { ThemedText } from '../../../components';

export default function CodeValue({ formatted, emptyValue = '—', theme }) {
  if (formatted == null) {
    return <ThemedText style={{ color: theme?.colors?.muted }}>{emptyValue}</ThemedText>;
  }
  return (
    <code style={{
      fontFamily: 'monospace',
      fontSize: '0.9em',
      padding: '2px 6px',
      borderRadius: 4,
      backgroundColor: theme?.colors?.backgroundAlt || '#f3f4f6',
    }}>
      {formatted}
    </code>
  );
}
